const gsap = window.gsap

class Cursor extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.cursorSettings = {
      x: -200,
      y: -200,
    }

    if (window.innerWidth < 900) return

    setTimeout(() => {
      this.initialiseCursor()
    }, 500)
  }

  setupListeners () {
    this.initialiseZoomCursor()
    this.initialiseCarouselCursor()
    this.initialiseVideoCursor()
    this.initialiseNoCursor()

    this.listeners.add(
      document,
      'UPDATE_CURSOR_SETTINGS',
      this.updateCursorSettings.bind(this),
    )
  }

  updateCursorSettings (event) {
    if (!event?.detail?.cursorX || !event?.detail?.cursorY) return
    this.cursorSettings.x = event.detail.cursorX
    this.cursorSettings.y = event.detail.cursorY
  }

  initialiseCursor () {
    this.cursorSettings.x = -100
    this.cursorSettings.y = -100

    document.addEventListener('mousemove', e => {
      this.cursorSettings.x = e.clientX
      this.cursorSettings.y = e.clientY
    })

    const renderCursor = () => {
      if (!this.els?.circle?.exists) return
      gsap.to(this.els.circle.element, 0.5, {
        x: this.cursorSettings.x,
        y: this.cursorSettings.y,
      })

      requestAnimationFrame(renderCursor)
    }

    requestAnimationFrame(renderCursor)

    document.body.classList.add(`util-HideCursor`)
  }

  initialiseZoomCursor () {
    if (!this.zoomEls) return
    this.zoomEls.forEach(zoomEl => {
      this.listeners.add(zoomEl, 'mouseenter', this.handleZoomEnter.bind(this))
      this.listeners.add(zoomEl, 'mouseleave', this.handleZoomLeave.bind(this))
    })
  }

  handleZoomEnter () {
    this.classList.add(`cur-Cursor-zoomActive`)
  }

  handleZoomLeave () {
    this.classList.remove(`cur-Cursor-zoomActive`)
  }

  initialiseCarouselCursor () {
    if (!this.carouselEls) return
    this.carouselEls.forEach(carouselEl => {
      this.listeners.add(
        carouselEl,
        'mouseenter',
        this.handleCarouselEnter.bind(this),
      )
      this.listeners.add(
        carouselEl,
        'mouseleave',
        this.handleCarouselLeave.bind(this),
      )
    })
  }

  handleCarouselEnter () {
    this.classList.add(`cur-Cursor-carouselActive`)
  }

  handleCarouselLeave () {
    this.classList.remove(`cur-Cursor-carouselActive`)
  }

  initialiseVideoCursor () {
    if (!this.videoEls) return
    this.videoEls.forEach(videoEl => {
      this.listeners.add(
        videoEl,
        'mouseenter',
        this.handleVideoEnter.bind(this),
      )
      this.listeners.add(
        videoEl,
        'mouseleave',
        this.handleVideoLeave.bind(this),
      )
    })
  }

  handleVideoEnter () {
    this.classList.add(`cur-Cursor-videoActive`)
  }

  handleVideoLeave () {
    this.classList.remove(`cur-Cursor-videoActive`)
  }

  initialiseNoCursor () {
    if (!this.noCursorEls) return
    this.noCursorEls.forEach(noCursorEl => {
      this.listeners.add(
        noCursorEl,
        'mouseenter',
        this.handleNoCursorEnter.bind(this),
      )
      this.listeners.add(
        noCursorEl,
        'mouseleave',
        this.handleNoCursorLeave.bind(this),
      )
    })
  }

  handleNoCursorEnter () {
    this.setAttribute(`data-disable-custom-cursor`, ``)
  }

  handleNoCursorLeave () {
    this.removeAttribute(`data-disable-custom-cursor`)
  }

  get zoomEls () {
    return this.externalEls?.zoom?.elements
  }

  get carouselEls () {
    return this.externalEls?.carousel?.elements
  }

  get videoEls () {
    return this.externalEls?.video?.elements
  }

  get noCursorEls () {
    return this.externalEls?.none?.elements
  }
}

if (!customElements.get('custom-cursor')) {
  customElements.define('custom-cursor', Cursor)
}
